module.exports = __webpack_public_path__ + "img/product3.777ef00d.png";